import Model from '@/lib/data/Model';

class Currency extends Model {
    static idProperty = 'id';

    fields = [
        { name: 'id' },
        { name: 'currency_name' },
        { name: 'record_state', type: 'int', defaultValue: 1 },
    ];

    /**
     * Create the User object
     *
     * @param {Object} data - Seed data for this object.
     */
    constructor(data) {
        super(data);
        this.init();
    }
}

export default Currency;
